import { useForm } from '../../../../Form';
import { Group } from '../../../../Layout/Group';
import { Stack } from '../../../../Layout/Stack';
import { Box } from '../../../../Miscellaneous/Box';
import { Title } from '../../../../Typography/Title/Title';
import { UserInfoForm, UserInfoFormType } from '../../../molecules/forms/UserInfoForm';

const DonorInfoForm = ({
  title,
  required,
  isPhoneNumberRequired,
  id,
  useFormListValidator,
  initialValues,
}: {
  title: string;
  required: boolean;
  isPhoneNumberRequired: boolean;
  id: string;
  useFormListValidator?: <TForm extends ReturnType<typeof useForm<any>>>(args: {
    form: TForm;
    id: string;
  }) => void;
  initialValues?: Partial<UserInfoFormType>;
}) => {
  return (
    <Stack>
      <Group gap={4}>
        <Title order={4}>{title}</Title>
        {required && (
          <Box c="cerise.7" fz={'sm'} fw={500}>
            *
          </Box>
        )}
      </Group>
      <UserInfoForm
        required={required}
        isPhoneNumberRequired={isPhoneNumberRequired}
        id={id}
        useFormListValidator={useFormListValidator}
        initialValues={initialValues}
      />
    </Stack>
  );
};

export { DonorInfoForm };
